import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-close\">\n  <path fill=\"currentColor\" d=\"M16 14.8L11.2 10l4.799-4.8-1.2-1.199L10 8.8 5.201 4l-1.2 1.2 4.8 4.8L4 14.8 5.2 16l4.8-4.801 4.8 4.8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol